import React, { useState } from 'react';
import { useAppDispatch } from 'reducers/index';
import { FileInfo } from '@uploadcare/react-widget';
import { saveUploadcareImageToZola } from 'actions/UploadcareActions';
import { ZolaFileResponseType } from 'actions/types/UploadcareActions';
import openUploadcareModal from '@zola-helpers/client/dist/es/uploadcare/openUploadcareModal';
import UploadInterface from 'components/common/ImageUploadV2/UploadInterface';

import type { UploadcareModalProps } from '@zola-helpers/client/dist/es/uploadcare/openUploadcareModal';

type ImageUploadV2PProps = Omit<UploadcareModalProps, 'onUploadcareFileReady'> & {
  onUploadComplete: (zolaFile: ZolaFileResponseType) => void;
  imageUrl?: string | null;
  onClearImage: () => void;
  previewShape?: 'default' | 'circle';
  className?: string;
};

const ImageUploadV2 = ({
  onUploadComplete,
  imageUrl,
  onClearImage,
  previewShape,
  className,
  ...UploadcareModalOptions
}: ImageUploadV2PProps): JSX.Element => {
  const [isBusy, setIsBusy] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  function openUploadcare() {
    setIsBusy(false);
    const handleOnFileReady = (uploadcareFile: FileInfo) => {
      dispatch(saveUploadcareImageToZola(uploadcareFile))
        .then((zolaFile: ZolaFileResponseType) => {
          onUploadComplete(zolaFile);
        })
        .finally(() => {
          setIsBusy(false);
        });
    };
    openUploadcareModal({
      ...UploadcareModalOptions,
      onUploadcareFileReady: file => {
        if (file && typeof file !== 'string') {
          handleOnFileReady(file);
        }
      },
    });
  }
  return (
    <div className={className}>
      <UploadInterface
        previewShape={previewShape}
        busy={isBusy}
        onClearImage={onClearImage}
        imageUrl={imageUrl}
        onClick={openUploadcare}
      />
    </div>
  );
};

export default ImageUploadV2;
